"use client";

import Link from "next/link";
import { Instagram, Facebook, Linkedin, Youtube, Phone, Mail, ArrowRight, Menu, X } from "lucide-react";
import { useState } from "react";
import UserAccountDropdown from "@/app/components/shared/UserAccountDropDown";


const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  const socialLinks = [
    { platform: "Instagram", href: "https://www.instagram.com/", icon: <Instagram size={18} /> },
    { platform: "Facebook", href: "https://www.facebook.com/profile.php?id=100068595636186", icon: <Facebook size={18} /> },
    { platform: "Youtube", href: "https://www.youtube.com/", icon: <Youtube size={18} /> },
    { platform: "LinkedIn", href: "https://www.linkedin.com/", icon: <Linkedin size={18} /> },
  ];

  const navLinks = [
    { link: "Home", href: "/" },
    { link: "About Us", href: "/about-us" },
    { link: "Our programs", href: "/our-programs" },
    { link: "Resources", href: "/resources" },
    { link: "Contact Us", href: "/contact-us" },
  ];

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">

      {/* Top bar */}
      <div className="w-full bg-secondary text-white text-sm flex flex-col md:flex-row md:items-center md:justify-between px-2 md:px-20 py-2 gap-2">
        <div className="flex items-start justify-center">
          <h3 className="text-center hidden md:flex md:text-left text-sm md:text-base border-none md:border-r-2 md:border-white md:pr-6">
            We are guardians of indigenous seeds.
          </h3>

          <div className="flex flex-nowrap justify-center md:justify-center gap-6 text-[12px] md:text-base md:pl-4 md:border-l-2 md:border-accent">
            <div className="flex items-center justify-center gap-2">
              <Phone size={14} />
              <h4 className="text-white flex gap-2 flex-wrap">
                <a href="https://wa.me/254720329614" target="_blank" rel="noopener noreferrer" className="hover:underline"
                >
                  +254 720 329614
                </a>
                /
                <a href="https://wa.me/254715492896" target="_blank" rel="noopener noreferrer" className="hover:underline"
                >
                  +254 715 492 896
                </a>
              </h4>

            </div>

            <div className="flex items-center justify-center gap-2">
              <Mail size={14} />
              <Link href="mailto:info@edenseedfarms.com" className="text-white hover:text-accent">info@edenseedfarms.com</Link>
            </div>
          </div>
        </div>

        <div className="hidden md:flex items-center justify-center md:justify-end gap-4">
          {socialLinks.map((social, index) => (
            <Link key={index} href={social.href}>{social.icon}</Link>
          ))}
          <div className="hidden lg:block ml-10">
            <UserAccountDropdown onLoginClick={() => setAuthOpen(true)} />
          </div>
        </div>
        
      </div>

      {/* Main navbar */}
      <nav className="flex items-center justify-between w-full px-4 md:px-20 py-4 bg-white">

        {/* Logo */}
        <Link href="/" className="text-[18px] md:text-[22px] uppercase font-semibold">
          Eden Indigenous Seed Farms
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden lg:flex items-center gap-10 md:gap-18">
          {navLinks.map((item, index) => (
            <Link key={index} href={item.href} className="text-base hover:text-accent transition-colors">
              {item.link}
            </Link>
          ))}
        </div>

        {/* CTA Desktop */}
        <div className="hidden lg:flex">
          <Link href="/join-us" className="flex items-center text-sm px-4 py-3 gap-2 bg-accent text-black">
            Be our partner <ArrowRight size={18} />
          </Link>
        </div>

        {/* Hamburger (mobile) */}
        <button
          className="lg:hidden"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {/* Mobile Slide Menu */}
      <div
        className={`lg:hidden fixed top-0 right-0 h-full w-[70%] max-w-[320px] bg-white shadow-lg p-6 transition-transform duration-300 ${
          mobileOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col gap-6 mt-14">
          {navLinks.map((item, index) => (
            <Link
              key={index}
              href={item.href}
              className="text-lg font-light hover:text-accent"
              onClick={() => setMobileOpen(false)}
            >
              {item.link}
            </Link>
          ))}

          <Link
            href="/join-us"
            className="flex items-center justify-center text-base px-4 py-3 gap-2 bg-accent text-black"
          >
            Be our partner <ArrowRight />
          </Link>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
